import { getCommonEndPoints } from './common'

function getEndPoints(options) {
  return {
    ...getCommonEndPoints(options),
  }
}
export { getEndPoints }
